import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CurrencyRateModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { CurrencyRateAction } from '../actions';
import { CurrencyRateReducer } from '../reducers';
import { CurrencyRateSelector } from '../selectors';

@Injectable()
export class CurrencyRateFacade {
  selectedItem$ = this._store.select(CurrencyRateSelector.selectCurrencyRate);
  constructor(private _store: Store<CurrencyRateReducer.CurrencyRateState>) {}

  /**
   * Get @CurrencyRateModel by id
   */
  getById(id: number): Observable<CurrencyRateModel | null> {
    this._store.dispatch(CurrencyRateAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<CurrencyRateModel | null>;
  }
}
